import { FAQService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    categoryDataStatus: 'loading',
    category: {},
    categories: {},
    questions: {},
    categoriesStatus: {},
    questionsStatus: {},
    categoryData: {},
    questionForm: {},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
        state.categoryDataStatus = 'loading'
        state.questionForm = {}
    },
    createQuestionForm(state) {
        state.status = 'success'
        state.questionForm = {}
    },
    successCategories(state, categories) {
        state.categoriesStatus = 'success'
        state.categories = categories
    },
    successQuestions(state, questions) {
        state.questionsStatus = 'success'
        state.questions = questions
    },
    successCategory(state, category) {
        state.categoryDataStatus = 'success'
        state.categoryData = category
    },
    successQuestion(state, question) {
        state.status = 'success'
        state.questionForm = question
    },
    fail(state) {
        state.status       = 'fail'
    },
}

const getters = {
    status: ({status}) => status,
    category: ({category}) => category,
    categories: ({categories}) => categories,
    questions: ({questions}) => questions,
    categoryData: ({categoryData}) => categoryData,
    categoriesStatus: ({categoriesStatus}) => categoriesStatus,
    categoryDataStatus: ({categoryDataStatus}) => categoryDataStatus,
    questionForm: ({questionForm}) => questionForm,
}

const actions = {
    fetchCategories({commit}) {
        commit('loading')
        return FAQService.fetchCategories().then(response => {
            commit('successCategories', response.data.data.data)
        })
    },

    fetchQuestions({commit}, hashid) {
        return FAQService.fetchQuestions(hashid).then(response => {
            commit('successQuestions', response.data.data)
        })
    },
    findQuestion({commit}, hashid) {
        commit('loading')
        return FAQService.findQuestion(hashid).then(response => {
            commit('successQuestion', response.data.data)
        })
    },
    createQuestionForm({commit}) {
        commit('createQuestionForm')
    }
}
export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}